import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { useTheme } from "@mui/material";

// Keyframes for spinning animation
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Keyframes for filling animation
const fillAndEmpty = keyframes`
  0%, 100% {
    stroke-dasharray: 0, 283; /* Start with no fill */
  }
  50% {
    stroke-dasharray: 283, 0; /* Full fill */
  }
`;

// Preloader container with themed background
const PreloaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backgroundColor || '#121212'};
`;

// SVG Circle styled for preloader
const Loader = styled.svg`
  width: 100px;
  height: 100px;
  animation: ${spin} 2s linear infinite;
`;

const Ring = styled.circle`
  stroke-linecap: round;
  animation: ${fillAndEmpty} 2s ease-in-out infinite;
  stroke: ${props => props.color};
  animation-delay: ${props => props.delay || '0s'};
`;

const Preloader = () => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const secondaryColor = theme.palette.secondary.main;
  const backgroundColor = theme.palette.mode === 'dark' 
    ? theme.palette.background.default 
    : theme.palette.background.paper;

  return (
    <PreloaderContainer backgroundColor={backgroundColor}>
      <Loader viewBox="0 0 100 100">
        <Ring cx="50" cy="50" r="45" strokeWidth="5" fill="none" color={primaryColor} delay="0s" />
        <Ring cx="50" cy="50" r="30" strokeWidth="5" fill="none" color={secondaryColor} delay="0.5s" />
      </Loader>
    </PreloaderContainer>
  );
};

export default Preloader;
